<template>
  <div
    id="driverLicense"
    class="modal fade bd-example-modal-lg"
    tabindex="-1"
    role="dialog"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h3 class="modal-title" id="exampleModalLabel">
            需要提醒審查的司機列表
            <span>({{ count }})</span>
          </h3>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <table class="table table-striped jambo_table bulk_action">
            <thead>
              <tr class="headings fontSize16">
                <th
                  v-for="head in HEAD"
                  :key="head"
                  class="column-title word_center"
                >
                  {{ head }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                class="text_hailing fontSize16"
                v-for="row in list"
                :key="row.callNumber"
              >
                <td class="word_center">{{ row.callNumber }}-{{ row.name }}</td>
                <td class="word_center">{{ row.account }}</td>
                <td class="column-title word_center">{{ row.birthday }}</td>
                <td class="column-title word_center">
                  {{ row.receiveCarLicenseDate }}
                </td>
                <td class="column-title word_center">
                  {{ row.carLeaveFactoryDate }}
                </td>
                <td class="word_center">
                  {{ row.isProfessionalLicense ? 'V' : '-'
                  }}{{
                    row.isProfessionalLicense === false
                      ? '-' + row.professionExpiredType
                      : ''
                  }}
                </td>
                <td class="word_center">
                  {{ row.isRegistrationCertificate ? 'Ｖ' : '-' }}
                </td>
                <td class="word_center">
                  {{ row.isVehicalInspect ? 'Ｖ' : '-' }}
                </td>
                <td class="word_center">
                  {{ row.isTaxiMeterInspect ? 'Ｖ' : '-' }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-dismiss="modal">
            關閉
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { reqDriverAuditList } from '@/api/driverList'
import { Notification, Loading } from 'element-ui'
import { driverAudit } from '@/constants/tableHead'

export default {
  data() {
    return {
      list: [],
      count: null,
    }
  },
  methods: {
    async fetch() {
      const loading = Loading.service()
      try {
        const { result } = await reqDriverAuditList()
        this.list = result.list
        this.count = result.count
      } catch (e) {
        console.error(e)
        Notification({
          title: '錯誤',
          message: '獲取司機列表發生錯誤，請稍後再試',
          type: 'error',
        })
      } finally {
        loading.close()
      }
    },
    showModal() {
      $('#driverLicense').modal('show')
      this.fetch()
    },
  },
  created() {
    this.HEAD = driverAudit
  },
}
</script>



// WEBPACK FOOTER //
// src/pages/driver/components/DriverLicenseModal.vue